import "./style.scss";
import React, { useEffect, useState } from "react";

const Dropdown = ({ options, selectedOption, label, error, setIsOpenAction, isOpen, handleOptionSelect }) => {

  // const handleOptionSelect = (option) => {
  //   setSelectedOption(option);
  //   setIsOpen(false);
  // };

  return (
    <>
      <div className="selectLabel">{label}</div>
      <div
        className="fd_dropdown_container"
        onClick={() => setIsOpenAction(!isOpen)}
      >
        <div className="fd_dropdown_header">
          {selectedOption ? selectedOption.label : 'Select'}
          <span style={isOpen ? { transform: 'rotate(180deg)' } : {}}>
          <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 -0.000488281L17.6603 8.99951H0.339745L9 -0.000488281Z" fill="#B5BF00"/>
</svg>

          </span>
        </div>
        {
          <ul className={`${isOpen ? "fd_dropdown_options open" : "fd_dropdown_options"}`}>
            {options.map((option) => (
              <li key={option.value} onClick={() => handleOptionSelect(option)}>
                   
                    <span className={`${  selectedOption === null ? "fd_check" : selectedOption.label === option.label ? "fd_check checked" : "fd_check"}`}></span>    <span>{option.label}</span> 
              </li>
            ))}
          </ul>
        }
      </div>
      <div className="errorText">{error}</div>
    </>
  );
};

export default Dropdown;
